import * as actionTypes from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import { Language } from '../../domain/Language';

export const fetchLanguageStart = () => ({
  type: actionTypes.FETCH_LANGUAGE_START,
});

export const fetchLanguageSuccess = (language: Language) => ({
  type: actionTypes.FETCH_LANGUAGE_SUCCESS,
  language,
});

export const fetchLanguageFail = (languageError: HttpError) => ({
  type: actionTypes.FETCH_LANGUAGE_FAIL,
  languageError,
});

export const fetchLanguagesStart = () => ({
  type: actionTypes.FETCH_LANGUAGES_START,
});

export const fetchLanguagesSuccess = (languages: Language[]) => ({
  type: actionTypes.FETCH_LANGUAGES_SUCCESS,
  languages,
});

export const fetchLanguagesFail = (languagesError: HttpError) => ({
  type: actionTypes.FETCH_LANGUAGES_FAIL,
  languagesError,
});
